import { createSlice } from '@reduxjs/toolkit';
import { createModel, deleteModelById } from '../thunks/models';
import { createBrand, deleteBrandById } from '../thunks/brands';
import { createResolution, deleteResolutionById } from '../thunks/resolutions';
import { createEventGroup, deleteEventGroupById } from '../thunks/eventGroups';
import { createEvent, deleteEventById } from '../thunks/events';
import { deleteDeviceById, getDevicesByCustomerId } from '../thunks/devices';
import {
  createEmergencyContact,
  deleteEmergencyContactById,
} from '../thunks/emergencyContacts';
import {
  createEmergencyContactList,
  deleteEmergencyContactListById,
} from '../thunks/emergencyContactLists';
import { createNewCustomer, deleteCustomerById } from '../thunks/customers';

export const currentWorkspacesSlice = createSlice({
  name: 'currentWorkspace',
  initialState: {
    id: null,
    devices: [],
    users: [],
    customers: [],
    invitations: [],
    brands: [],
    models: [],
    events: [],
    resolutions: [],
    eventGroups: [],
    emergencyContacts: [],
    emergencyContactLists: [],
  },
  reducers: {
    setCurrentWorkspace: (state, action) => {
      // ?????
      state.id = action.payload;
      state.users = [];
      state.customers = [];
      state.users = [];
      state.invitations = [];
      state.brands = [];
      state.models = [];
      state.events = [];
      state.resolutions = [];
      state.eventGroups = [];
      state.emergencyContacts = [];
      state.emergencyContactLists = [];
    },
    removeCurrentWorkspace: (state) => {
      state.id = null;
      state.users = [];
      state.customers = [];
      state.users = [];
      state.invitations = [];
      state.brands = [];
      state.models = [];
      state.events = [];
      state.resolutions = [];
      state.eventGroups = [];
      state.emergencyContacts = [];
      state.emergencyContactLists = [];
    },
    // users
    setCurrentWorkspaceUsersIds: (state, action) => {
      state.users = action.payload || [];
    },
    // devices
    setCurrentWorkspaceDevicesIds: (state, action) => {
      state.devices = action.payload || [];
    },
    setCurrentWorkspaceDeviceId: (state, action) => {
      state.devices.push(action.payload);
    },
    // Customers
    setCurrentWorkspaceCustomersIds: (state, action) => {
      state.customers = action.payload || [];
    },
    // invitations
    setCurrentWorkspaceInvitationsIds: (state, action) => {
      state.invitations = action.payload || [];
    },
    // brands
    setCurrentWorkspaceBrandsIds: (state, action) => {
      state.brands = action.payload || [];
    },
    // models
    setCurrentWorkspaceModelsIds: (state, action) => {
      state.models = action.payload || [];
    },
    // events
    setCurrentWorkspaceEventsIds: (state, action) => {
      state.events = action.payload || [];
    },
    // resolutions
    setCurrentWorkspaceResolutionsIds: (state, action) => {
      state.resolutions = action.payload || [];
    },
    // event groups
    setCurrentWorkspaceEventGroupIds: (state, action) => {
      state.eventGroups = action.payload || [];
    },
    // emergency contacts
    setCurrentWorkspaceEmergencyContactIds: (state, action) => {
      state.emergencyContacts = action.payload || [];
    },
    // emergency contacts list
    setCurrentWorkspaceEmergencyContactListIds: (state, action) => {
      state.emergencyContactLists = action.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBrand.fulfilled, (state, action) => {
        state.brands.push(action.payload.id);
      })
      .addCase(deleteBrandById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.brands = state.brands.filter((brandId) => brandId !== id);
      })
      .addCase(createModel.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.models.push(id);
      })
      .addCase(deleteModelById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.models = state.models.filter((modelId) => modelId !== id);
      })
      .addCase(createResolution.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.resolutions.push(id);
      })
      .addCase(deleteResolutionById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.resolutions = state.resolutions.filter(
          (resolutionId) => resolutionId !== id
        );
      })
      .addCase(createEventGroup.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.eventGroups.push(id);
      })
      .addCase(deleteEventGroupById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.eventGroups = state.eventGroups.filter(
          (eventGroupId) => eventGroupId !== id
        );
      })
      .addCase(createEvent.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.events.push(id);
      })
      .addCase(deleteEventById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.events = state.events.filter((eventId) => eventId !== id);
      })
      .addCase(deleteDeviceById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.devices = state.devices.filter((deviceId) => deviceId !== id);
      })
      .addCase(createEmergencyContact.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.emergencyContacts.push(id);
      })
      .addCase(deleteEmergencyContactById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.emergencyContacts = state.emergencyContacts.filter(
          (emergencyContactId) => emergencyContactId !== id
        );
      })
      .addCase(createEmergencyContactList.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.emergencyContactLists.push(id);
      })
      .addCase(deleteEmergencyContactListById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.emergencyContactLists = state.emergencyContactLists.filter(
          (emergencyContactListId) => emergencyContactListId !== id
        );
      })
      .addCase(createNewCustomer.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.customers.push(id);
      })
      .addCase(deleteCustomerById.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.customers = state.customers.filter((customer) => customer !== id);
      })
      .addCase(getDevicesByCustomerId.fulfilled, (state, action) => {
        const { devices } = action.payload;

        const customerDevices = devices.reduce((accumulator, device) => {
          if (device.workspaceId === state.id) accumulator.push(device.id);
          return accumulator;
        }, []);

        state.devices = state.devices.concat(customerDevices);
      });
  },
});

export const {
  setCurrentWorkspace,
  removeCurrentWorkspace,
  // users
  setCurrentWorkspaceUsersIds,
  // devices
  setCurrentWorkspaceDevicesIds,
  setCurrentWorkspaceDeviceId,
  setDevicePosition,
  // Customers
  setCurrentWorkspaceCustomersIds,
  // invitations
  setCurrentWorkspaceInvitationsIds,
  // brands
  setCurrentWorkspaceBrandsIds,
  // models
  setCurrentWorkspaceModelsIds,
  // events
  setCurrentWorkspaceEventsIds,
  // resolutions
  setCurrentWorkspaceResolutionsIds,
  // events
  setCurrentWorkspaceEventGroupIds,
  // emergency contacts
  setCurrentWorkspaceEmergencyContactIds,
  // emergency contacts list
  setCurrentWorkspaceEmergencyContactListIds,
} = currentWorkspacesSlice.actions;

export default currentWorkspacesSlice.reducer;
